import { SortOrder } from '@Utils/helpers/sortingHelpers';
import fileDownload from 'js-file-download';
import _groupBy from 'lodash/groupBy';
import _orderBy from 'lodash/orderBy';
import {
    DownloadFilesSortField,
    IQcFileResult,
    IUploadedFile,
} from './Interfaces';

export function downloadFile(
    fileName: string,
    fileExtension: string,
    data: string
) {
    fileDownload(data, `${fileName}.${fileExtension}`);
}

export function extrapolateData(rawData) {
    const featureData = rawData.features.map((feature) => {
        const gd = JSON.parse(feature.properties.generic_data);
        const parsedFeatureData = gd[0];
        parsedFeatureData['lat'] = feature.properties.lat;
        parsedFeatureData['long'] = feature.properties.long;
        parsedFeatureData['entityId'] = feature.properties.entity_id;
        return parsedFeatureData;
    });

    const grouped = _groupBy(featureData, 'entityId');
    const output = [];
    for (const feature in grouped) {
        output.push(grouped[feature][0]);
    }

    return convertJSONToCSV(output);
}

export function getHeaders(jsonObjArray) {
    const headers = [];
    jsonObjArray.forEach((obj) => {
        for (const header in obj) {
            if (headers.indexOf(header) === -1 && header !== 'entityId') {
                headers.push(header);
            }
        }
    });

    return headers.sort();
}

export function convertJSONToCSV(jsonObjArray) {
    let str = '';
    const headers = getHeaders(jsonObjArray);

    for (let i = 0; i < headers.length; i++) {
        if (i !== 0) str += ',';
        str += headers[i];
    }

    str += '\r\n';

    for (let i = 0; i < jsonObjArray.length; i++) {
        let line = '';
        let j = 0;
        headers.forEach((h) => {
            if (j != 0) line += ',';
            let value = jsonObjArray[i][h];
            if (value.toString().indexOf(',') > -1) {
                value = `"${value}"`;
            }
            line += value ? value : '';
            j++;
        });

        str += line + '\r\n';
    }

    return str;
}

export function getSortedFiles(
    files: Array<IQcFileResult>,
    order: SortOrder,
    field: DownloadFilesSortField
): Array<IQcFileResult> {
    const sortOrderStr = order === SortOrder.ASC ? 'asc' : 'desc';

    switch (field) {
        case DownloadFilesSortField.TITLE:
            return _orderBy(files, ['QC_inspection_name'], [sortOrderStr]);
        case DownloadFilesSortField.CREATED_DATE:
            return _orderBy(
                files,
                [(f) => new Date(f.QC_inspection_timestamp)],
                [sortOrderStr]
            );
        case DownloadFilesSortField.AUTHOR:
            return _orderBy(files, ['userName'], [sortOrderStr]);
        default:
            return files;
    }
}
